'use client';

import { ComponentProps, ReactNode, useState } from 'react';

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../Select/Select';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../Tabs/Tabs';

interface Tab {
  id: string;
  title: string;
  content: ReactNode;
}

interface Props {
  items: Tab[];
  ariaLabel?: string;
  tabsProps?: ComponentProps<typeof Tabs>;
  selectProps?: ComponentProps<typeof Select>;
}

const SelectOnMobileTabsOnDesktop = ({ items, tabsProps, selectProps, ariaLabel }: Props) => {
  const [currentTab, setCurrentTab] = useState(items[0].id);

  const commonTabsAndSelectProps = {
    value: currentTab,
    onValueChange: (value: string) => {
      setCurrentTab(value);
    },
  };

  return (
    <Tabs {...commonTabsAndSelectProps} {...tabsProps}>
      <TabsList className="hidden lg:inline-flex">
        {items.map(({ id, title }) => (
          <TabsTrigger key={id} value={id}>
            {title}
          </TabsTrigger>
        ))}
      </TabsList>
      <Select {...commonTabsAndSelectProps} {...selectProps}>
        <SelectTrigger
          className="font-semibold text-gray-500 lg:hidden"
          {...(ariaLabel && { 'aria-label': ariaLabel })}
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {items.map(({ id, title }) => (
            <SelectItem key={id} value={id}>
              {title}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {items.map(({ id, content }) => (
        <TabsContent key={id} value={id} className="pt-12">
          {content}
        </TabsContent>
      ))}
    </Tabs>
  );
};

export { SelectOnMobileTabsOnDesktop };
